import { render } from "./UserAssignmentModal.vue?vue&type=template&id=59a1437c&scoped=true"
import script from "./UserAssignmentModal.vue?vue&type=script&lang=js"
export * from "./UserAssignmentModal.vue?vue&type=script&lang=js"

import "./UserAssignmentModal.vue?vue&type=style&index=0&id=59a1437c&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a1437c"]])

export default __exports__